import moment from 'moment';
import { CONSTANTS } from 'services/constants';
import { isNaN } from 'lodash';

export function dateFormatter(params)
{
    return moment(params.value).format(CONSTANTS.FORMATS.DATE);
}

export function dateHourFormatter(date, format = null)
{
    if (!date) return null;

    const finalDate = moment.isMoment(date) ? date : moment(date, format);

    return finalDate.isValid() ? finalDate.format(CONSTANTS.FORMATS.DATE) : '';
}

export function humanReadableShortDate(date, format = null)
{
    if (!date) return null;

    const finalDate = moment.isMoment(date) ? date : moment(date, format);

    return finalDate.isValid() ? finalDate.format(CONSTANTS.FORMATS.HUMAN_READABLE_SHORT_DATE) : '';
}

export function dayNameOfWeek(date, format = null)
{
    const finalDate = moment.isMoment(date) ? date : moment(date, format);

    return finalDate.isValid() ? finalDate.format(CONSTANTS.FORMATS.DAY_NAME_OF_WEEK) : '';
}

export function firstName(fullname)
{
    const items = `${fullname}`.split(' ');

    return items[0] || '';
}

export function lastName(fullname)
{
    const items = `${fullname}`.split(' ');

    items.shift();

    return items.join(' ');
}

export function formatNumber(number, precision = 2)
{
    let _number = number;

    if (typeof _number !== 'number')
    {
        _number = parseFloat(number).toLocaleString('en-US');
    }

    const parseOptions = {
        minimumFractionDigits: precision,
        maximumFractionDigits: precision,
    };

    return isNaN(_number) ? (0).toLocaleString('en-US', parseOptions) : _number.toLocaleString('en-US', parseOptions);
}

export function formatCurrency(number, precision = 2, symbol = '$', symbolLeft = true)
{
    return `${symbolLeft ? symbol : ''}${formatNumber(number, precision)}${!symbolLeft ? symbol : ''}`;
}

export function formatAmount(amount, currency)
{
    return currency === 'USD' ? formatCurrency(amount, 2) : formatCurrency(amount, 2, ` ${currency}`, false);
}
